export const BOOK_TEETIME = "BOOK_TEETIME";
export const GET_LISTING_BOOKING = "GET_LISTING_BOOKING";
export const CREATE_CUSTOMER = "CREATE_CUSTOMER";
export const CREATE_PAYMENT = "CREATE_PAYMENT";
export const FACILITES = "FACILITES";
export const ADD_FAV_CLUB = "ADD_FAV_CLUB";
export const GET_FAV_CLUB = "GET_FAV_CLUB";
